module.exports = __webpack_public_path__ + "static/media/business-trends.2da7944c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/valentines_day/business-trends.png
// module id = 315
// module chunks = 0